import { useState } from "react";
import { Drawer } from "antd";
import {
  FiChevronRight,
  FiSmartphone,
  FiTablet,
  FiWatch,
  FiGrid,
} from "react-icons/fi";
import BrandGrid from "../BrandGrid";

const MobileDrawer = ({ visible, onClose, isDarkMode, categories }) => {
  const [expandedCategory, setExpandedCategory] = useState(null);
  
  if (!categories) return null;

  return (
    <Drawer
      title={
        <div className="flex items-center gap-2">
          <img
            src="https://app.tap2cash.in/assets/logo.png"
            alt="Tap2Cash"
            className="w-auto h-8"
          />
        </div>
      }
      placement="left"
      onClose={onClose}
      open={visible}
      className={isDarkMode ? "dark-drawer" : ""}
      width={280}
      closable={false}
    >
      <div className="flex flex-col h-full">
        {/* Categories Section */}
        <div className="flex-1 pb-24 overflow-y-auto">
          {categories.map((category) => {
            const isExpanded = expandedCategory === category.id;
            const categoryBrands = category.brands || [];

            return (
              <div key={category.id} className="mb-1">
                <div
                  className={`flex items-center justify-between px-2 py-2 rounded-lg cursor-pointer transition-colors ${
                    isDarkMode 
                      ? "hover:bg-gray-800 text-gray-200" 
                      : "hover:bg-gray-50 text-gray-700"
                  }`}
                  onClick={() =>
                    setExpandedCategory(isExpanded ? null : category.id)
                  }
                >
                  <div className="flex items-center gap-2">
                    {category.image ? (
                      <img
                        src={category.image}
                        alt={category.name}
                        className="object-contain w-5 h-5"
                      />
                    ) : (
                      <div className="flex items-center justify-center w-5 h-5">
                        {category.name?.includes("Phone") ? (
                          <FiSmartphone size={14} className={isDarkMode ? "text-gray-400" : ""} />
                        ) : category.name?.includes("Tablet") ? (
                          <FiTablet size={14} className={isDarkMode ? "text-gray-400" : ""} />
                        ) : category.name?.includes("Watch") ? (
                          <FiWatch size={14} className={isDarkMode ? "text-gray-400" : ""} />
                        ) : (
                          <FiGrid size={14} className={isDarkMode ? "text-gray-400" : ""} />
                        )}
                      </div>
                    )}
                    <span className={`text-sm ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}>
                      {category.display_name || category.name}
                    </span>
                  </div>
                  {categoryBrands.length > 0 && (
                    <FiChevronRight
                      size={14}
                      className={`transition-transform ${isExpanded ? "rotate-90" : ""} ${
                        isDarkMode ? "text-gray-500" : "text-gray-400"
                      }`}
                    />
                  )}
                </div>

                {isExpanded && categoryBrands.length > 0 && (
                  <div className="mt-1 mb-2 ml-7">
                    <BrandGrid
                      brands={categoryBrands}
                      categorySlug={category.slug}
                      isDarkMode={isDarkMode}
                      onClose={onClose}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>

      <style jsx>{`
        .dark-drawer :global(.ant-drawer-content) {
          background-color: #1a1a1a;
        }
        .dark-drawer :global(.ant-drawer-header) {
          background-color: #1a1a1a;
          border-bottom-color: #2d2d2d;
        }
        .dark-drawer :global(.ant-drawer-title) {
          color: #ffffff;
        }
        .dark-drawer :global(.ant-drawer-body) {
          background-color: #1a1a1a;
        }
      `}</style>
    </Drawer>
  );
};

export default MobileDrawer;